export const languageArray = [
  { text: 'English', value: 'en' },
  // { text: 'Español', value: 'es' },
];
